<p-card styleClass="very-compact-card p-3">
  <h3 class="m-0">Созданные объекты</h3>

  @if (!loading()) {
    @if (items?.length) {
      <div
        class="mt-2 max-h-29rem overflow-y-auto overflow-x-hidden"
        (scroll)="onScrollEnd($any($event.target))">
        <crm-table
          [columns]="columns"
          [values]="items"
          [paginationLoading]="paginationLoading()"
          styleClass="card-table p-datatable-sm">
          <ng-template
            #rowTemplate
            let-item="item">
            <tr *ngIf="toItem(item) as item">
              <td>
                @if (item.template?.type === DocumentFileTemplateTypeEnum.DEAL) {
                  <a crmConditionalRouterLink [crmRouterLink]="['/deal/card/', item.commentary?.thread?.deal?.id]">
                    Сделка {{ item.commentary?.thread?.deal?.id }}
                  </a>
                }
              </td>
              <td>
                <p>{{ item.created | date: 'dd.MM.yyyy' }}</p>
              </td>
              <td>
                <p>{{ item.template?.type | documentFileTemplateTypeName }}</p>
              </td>
            </tr>
          </ng-template>
        </crm-table>
      </div>
    } @else {
      <p class="text-xl font-medium ml-1 p-3">Нет данных</p>
    }
  } @else {
    <crm-spinner top="mt-4 pb-0 mb-4 pb-4"></crm-spinner>
  }
</p-card>
